'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { BaseTypeStyle, BaseTypeStyleSkeleton } from './BaseTypeStyle';
export const getTypeStyle = (styleName) => forwardRef((props, ref) => (_jsx(BaseTypeStyle, { ref: ref, ...props, styleName: styleName })));
export const getTypeStyleSkeleton = (styleName) => {
    return (props) => (_jsx(BaseTypeStyleSkeleton, { ...props, styleName: styleName }));
};
//# sourceMappingURL=getTypeStyle.js.map